import { render } from "./download.vue?vue&type=template&id=6c8a75fe&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=6c8a75fe&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8a75fe"]])

export default __exports__